<template>
  <div>
    <div class="d-md-none">
      <div class="clearfix">
        <div class="filter-btn">
          <div class="js-filters-off">
            <i class="mr-2 icon-filter"></i> Filtrar resultados
          </div>
          <div class="js-filters-on d-none">
            <i class="mr-2 icon-angle-left"></i> Voltar
          </div>
        </div>
        <div class="clear-btn">
          <span class="light">
            <a class="light clear-btn" @click="clearSelections">
              <i class="mr-2 icon-trash-o"></i> Limpar Filtros
            </a>
          </span>
        </div>
      </div>
    </div>
    <div class="item d-none d-md-block">
      <a class="light clear-btn" @click="clearSelections">
        <i class="mr-2 icon-trash-o"></i> Limpar Filtros
      </a>
    </div>
    <div class="item item-active">Últimos Lançamentos</div>
    <div class="filters-items" id="filters-items">
      <div class="item">
        <button
          class="btn btn-link collapsed"
          type="button"
          data-toggle="collapse"
          data-target="#filter1"
          aria-expanded="false"
          aria-controls="manufacturer"
        >Código</button>
        <div id="filter1" class="collapse" aria-labelledby="filter1" data-parent="#filters-items">
          <div class="card-body">
            <div class="form-group">
              <input
                class="form-control"
                name="code"
                id="code"
                v-model="code"
                type="text"
                placeholder="Cód. do produto"
                @keyup.enter="filterReleases"
              >
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <button
          class="btn btn-link collapsed"
          type="button"
          data-toggle="collapse"
          data-target="#filter2"
          aria-expanded="false"
          aria-controls="manufacturer"
        >Data</button>
        <div id="filter2" class="collapse" aria-labelledby="filter2" data-parent="#filters-items">
          <div class="card-body row">
            <div class="form-group col-12">
              <label for="from-date">De</label>
              <input
                class="form-control"
                v-bind:class="fromDateErrors"
                name="from-date"
                ref="afterTarget"
                v-validate="'date_format:DD/MM/YYYY'"
                v-mask="'##/##/####'"
                id="from-date"
                v-model="fromDate"
                type="text"
                placeholder="DD/MM/AAAA"
                @keyup.enter="filterReleasesByDate"
              >
            </div>
            <div class="form-group col-12">
              <label for="from-date">Até</label>
              <input
                class="form-control"
                v-bind:class="toDateErrors"
                name="to-date"
                v-validate="'date_format:DD/MM/YYYY|after:afterTarget'"
                v-mask="'##/##/####'"
                id="to-date"
                v-model="toDate"
                type="text"
                placeholder="DD/MM/AAAA"
                @keyup.enter="filterReleasesByDate"
              >
            </div>
          </div>
          <button @click="filterReleasesByDate" class="col btn btn-primary btn-search">Buscar</button>
        </div>
      </div>
      <!-- <div class="item">
        <button
          class="btn btn-link collapsed"
          type="button"
          data-toggle="collapse"
          data-target="#filter2"
          aria-expanded="false"
          aria-controls="model"
        >Veículo</button>
        <div id="filter2" class="collapse" aria-labelledby="filter2" data-parent="#filters-items">
          <div class="card-body">
            <div class="mb-3 form-group">
              <label for="selectManufacturer">Selecione a fabricante</label>
              <select
                class="custom-select"
                name="selectManufacturer"
                id="manufacturer"
                v-model="selectedManufacturer"
              >
                <option value selected>Selecione a fabricante</option>
                <option v-for="manuf in manufacturers" :value="manuf">{{manuf.name}}</option>
              </select>
            </div>
            <div class="form-group" v-show="selectedManufacturer || selectedModel">
              <label for="selectModel">Selecione o modelo</label>
              <select class="custom-select" name="selectModel" id="model" v-model="selectedModel">
                <option value selected>Selecione o modelo</option>
                <option v-for="model in models" :value="model">{{model.model}}</option>
              </select>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <div class="item">
        <button
          class="btn btn-link collapsed"
          type="button"
          data-toggle="collapse"
          data-target="#filter3"
          aria-expanded="false"
          aria-controls="model"
        >Período</button>
        <div id="filter3" class="collapse" aria-labelledby="filter3" data-parent="#filters-items">
          <div class="card-body">
            <div class="mb-3 form-group">
              <label for="from">De:</label>
              <input class="form-control" type="date" :id="from" v-model="from">
            </div>
            <div class="form-group">
              <label for="to">Até:</label>
              <input class="form-control" type="date" :id="to" v-model="to">
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <div class="m-4 text-center">
      <a
        href="https://static.japanparts.com.br/Japanparts-2017-2018.zip"
        class="btn btn-primary"
      >
        <i class="icon-document-download"></i> Catálogo
      </a>
    </div>
  </div>
</template>

<script>
import ReleaseAPI from "@/api/release";

export default {
  data() {
    return {
      selectedFilters: [],
      filteredReleases: [],
      code: "",
      fromDate: "",
      toDate: "",
      manufacturers: [],
      selectedManufacturer: null,
      models: [],
      selectedModel: null,
      from: "",
      to: "",
      releasesPerPage: 15
    };
  },
  computed: {
    toDateErrors: function() {
      return {
        "is-valid text-success": !this.errors.has("to-date") && this.toDate,
        "is-invalid text-danger": this.errors.has("to-date") && this.toDate
      };
    },
    fromDateErrors: function() {
      return {
        "is-valid text-success": !this.errors.has("from-date") && this.fromDate,
        "is-invalid text-danger": this.errors.has("from-date") && this.fromDate
      };
    }
  },
  components: { ReleaseAPI },
  props: {
    releases: {
      type: Array,
      default: []
    },
  },
  mounted() {
    this.filteredReleases = this.releases;
    // this.getFilters();
    // this.clearSelections();
  },
  watch: {
    // code: function() {
    //   this.filterReleases();
    // },
    // selectedManufacturer: function(oldVal, newVal) {
    //   if (newVal != "") this.getModels();
    //   else this.selectedModel = "";
    // },
    // selectedModel: function() {
    //   this.filterReleases();
    // },
    // from: function() {
    //   this.filterReleases();
    // },
    // to: function() {
    //   this.filterReleases();
    // }
  },
  methods: {
    clearSelections() {
      (this.code = ""),
        (this.selectedManufacturer = null),
        (this.selectedModel = null),
        (this.fromDate = ""),
        (this.toDate = ""),
        (this.selectedFilters = []);
      this.filterReleases();
    },
    // getFilters() {
    //   this.getManufacturers();
    // },
    // getSelectedFilters() {
    //   this.selectedFilters = [];
    //   if (this.code != "") this.selectedFilters.push(`${this.code}`);
    //   if (this.from != "" && this.to != "")
    //     this.selectedFilters.push(`de ${this.from} até ${this.to}`);
    //   if (this.selectedModel != null && this.selectedModel != "")
    //     this.selectedFilters.push(
    //       `${this.selectedManufacturer.name} ${this.selectedModel.model}`
    //     );
    //   this.$emit("update:listReleaseFilters", this.selectedFilters);
    // },
    // async getManufacturers() {
    //   this.manufacturers = await ReleaseAPI.getManufacturers();
    // },
    // async getModels() {
    //   this.models = await ReleaseAPI.getModels(this.selectedManufacturer.id);
    // },
    // orderString(arr) {
    //   arr = arr.sort((a, b) => {
    //     return a.localeCompare(b);
    //   });
    //   return arr;
    // },
    async filterReleases() {
      // let filteredReleases = this.releases;
      // if (this.code != "") {
      //   filteredReleases = filteredReleases.filter(rel => {
      //     return rel.code.toUpperCase().includes(this.code.toUpperCase());
      //   });
      // }
      // if (
      //   this.selectedManufacturer != null &&
      //   this.selectedManufacturer != "" &&
      //   this.selectedModel != null &&
      //   this.selectedModel != ""
      // ) {
      //   filteredReleases = filteredReleases.filter(rel => {
      //     return rel.model
      //       .toUpperCase()
      //       .includes(this.selectedModel.model.toUpperCase());
      //   });
      // }
      // if (this.from != "" && this.to != "") {
      //   filteredReleases = filteredReleases.filter(rel => {
      //     return (
      //       Date.parse(rel.launch_date) >= Date.parse(this.from) &&
      //       Date.parse(rel.launch_date) <= Date.parse(this.to)
      //     );
      //   });
      // }
      // this.getSelectedFilters();
      // this.filteredReleases = filteredReleases;

      try {
        this.$emit("update:isLoading", true)

        const { hits, total } = await ReleaseAPI.getReleases(
          this.code,
          "",
          "",
          "",
          "",
          this.releasesPerPage);
        this.filteredReleases = hits;
        this.$emit("update:releases", { releases: this.filteredReleases, total });
        this.$emit("update:isLoading", false)

      } catch(error) {
        console.log(error)
      }

    },

    async filterReleasesByDate() {
      if (!this.errors.has("from-date") && !this.errors.has("to-date")) {
        const [formatedFromDate, formatedToDate] = this.convertToJSDateFormat([
          this.fromDate,
          this.toDate
        ]);

        try {
          this.$emit("update:isLoading", true)

          const { hits, total } = await ReleaseAPI.getReleases(
            "",
            formatedFromDate,
            formatedToDate,
            "",
            1,
            this.releasesPerPage
          );

          this.filteredReleases = hits;
          this.$emit("update:releases", { releases: this.filteredReleases, total });
           this.$emit("update:isLoading", false)
        } catch (error) {
          console.error(error)
        }
      }
    },

    convertToJSDateFormat(dates) {
      return dates.map(function(date) {
        const [day, month, year] = date.split("/");
        return new Date(`${month}/${day}/${year}`).toISOString();
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ReleaseFilters.vue